import * as React from "react";
import { useState, useEffect, FormEvent } from "react";
import { confirmAlert } from "react-confirm-alert";
/*MATERIAL COMPONENTS*/
import { DataGrid, GridColumns } from "@mui/x-data-grid";
import Grid from "@mui/material/Grid";
import {
  TextField,
  Tooltip,
  IconButton,
  Stack,
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
} from "@mui/material";
/* MATERIAL ICONS */
import NewIcon from "@mui/icons-material/InsertDriveFile";
import SaveIcon from "@mui/icons-material/Save";
import EraseIcon from "@mui/icons-material/Delete";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
/*CLASSES*/
import Email from "../../components/classes/EmailBroadcast";
import Grupo from "../../components/classes/GrupoBroadcast";
/*DATA FETCHING*/
import EmailDataset from "../../components/data/EmailBroadcastDataSet";
import GrupoDataset from "../../components/data/GrupoBroadcastDataSet";

/* HELPERS */
import PageHelper from "../../helper/pageHelper";
/* COMPONENTS */
import GrupoEmailsTopo from "./topo";
/*STYLES*/
import "./styles.css";
import AddCircle from "@mui/icons-material/AddCircle";
import { GrupoEmail } from "../../components/classes/GrupoBroadcastEmail";
import GrupoEmailDataset from "../../components/data/GrupoBroadcastEmailDataSet";
import GrupoEmailsModal from "./GrupoEmailsModal";
import GrupoRotinasModal from "./GrupoRotinasModal";

import { useTranslation } from "react-i18next";

/*INTERFACES*/
interface DataEmail {
  id: Number;
  endereco: String;
  criadoEm: String;
}
function createDataEmail(
  id: Number,
  endereco: String,
  criadoEm: String
): DataEmail {
  return {
    id,
    endereco,
    criadoEm,
  };
}
interface DataGrupo {
  id: Number;
  nome: String;
  criadoEm: String;
}
function createDataGrupo(
  id: Number,
  nome: String,
  criadoEm: String
): DataGrupo {
  return {
    id,
    nome,
    criadoEm,
  };
}

function formataData(value: Date): string {
  let frmDate: string = "";
  frmDate =
    String(value).substring(8, 10) +
    "/" +
    String(value).substring(5, 7) +
    "/" +
    String(value).substring(0, 4);
  return frmDate;
}

export default function GrupoEmailsDetalhe() {
  const { t } = useTranslation();

  const [email, setEmail] = useState(new Email());
  const [grupo, setGrupo] = useState(new Grupo());
  const [grupoId, setGrupoId] = useState(null);

  const dataEmail: EmailDataset = new EmailDataset();
  const dataGrupo: GrupoDataset = new GrupoDataset();
  const dataGrupoEmail: GrupoEmailDataset = new GrupoEmailDataset();

  const [habilita, setHabilita] = React.useState(false);
  const [open, setOpen] = React.useState(false);

  const [rowsEmail, setRowsEmail] = useState<DataEmail[]>([]);
  const [rowsGrupo, setRowsGrupo] = useState<DataGrupo[]>([]);
  const [rowsEmailsVinculados, setRowsEmailsVinculados] = useState<
    GrupoEmailRow[]
  >([]);
  const [rowsRotinasVinculadas, setRowsRotinasVinculadas] = useState<
    GrupoRotina[]
  >([]);

  const [pageSize, setPageSize] = useState(10);
  const [endereco, setEndereco] = useState("");

  const [idsGrupoSelecionados, setIdsGrupoSelecionados] = useState<number[]>(
    []
  );
  const [idsEmailsSelecionados, setIdsEmailsSelecionados] = useState<number[]>(
    []
  );

  const [mensagem, setMensagem] = React.useState("");
  const [severity, setSeverity] = React.useState(0);

  const [openEmailsVinculados, setOpenEmailsVinculados] = useState(false);
  const [openRotinasVinculadas, setOpenRotinasVinculadas] = useState(false);

  useEffect(() => {
    dataEmail.ListarAtivos().then((result) => {
      setRowsEmail((): DataEmail[] =>
        result.map((email: Email): DataEmail => {
          return createDataEmail(
            email.id,
            email.endereco,
            formataData(email.criadoEm)
          );
        })
      );

      setRowsRotinasVinculadas((): GrupoRotina[] =>
        result.map((item: Email) => {
          return {
            id: Number(item.id),
            nome: `${t("pages.emailsGroups.text.routine")} - ` + item.id,
          };
        })
      );
    });
  }, []);

  useEffect(() => {
    dataGrupo.ListarAtivos().then((result) => {
      setRowsGrupo((): DataGrupo[] =>
        result.map((grupo: Grupo): DataGrupo => {
          return createDataGrupo(
            grupo.id,
            grupo.nome,
            formataData(grupo.criadoEm)
          );
        })
      );
    });
  }, []);

  useEffect(() => {
    dataGrupoEmail.AllByGrupo(1).then((result) => {
      setRowsEmailsVinculados((): GrupoEmailRow[] =>
        result.map((item: GrupoEmail) => {
          return {
            id: item.grupoBroadcastEmailId,
            email: item.email,
          };
        })
      );
    });
  }, []);

  const columnsEmail: GridColumns = [
    {
      field: "id",
      headerName: "#",
      width: 80,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "endereco",
      headerName: t("pages.emailsGroups.text.registeredEmails"),
      width: 400,
      editable: false,
      headerAlign: "left",
      align: "left",
    },
  ];

  const columnsGrupo: GridColumns = [
    {
      field: "id",
      headerName: "#",
      width: 80,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "nome",
      headerName: t("pages.emailsGroups.text.registeredGroups"),
      width: 300,
      editable: false,
      headerAlign: "left",
      align: "left",
    },
    {
      field: " ",
      sortable: false,
      renderCell: (params) => {
        return (
          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={() => {
              setGrupoId(params.row.id);
              setOpenEmailsVinculados(true);
            }}
          >
            <small>{t("common.emails")}</small>
          </Button>
        );
      },
    },
    {
      field: "  ",
      sortable: false,
      width: 120,
      renderCell: (params) => {
        return (
          <Button
            size="small"
            variant="contained"
            color="primary"
            style={{ minWidth: "80px" }}
            onClick={() => {
              setGrupoId(params.row.id);
              setOpenRotinasVinculadas(true);
            }}
          >
            <small>{t("pages.emailsGroups.text.routines")}</small>
          </Button>
        );
      },
    },
  ];

  const columnsRotinasVinculadas: GridColumns = [
    {
      field: "id",
      headerName: "#",
      width: 80,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "nome",
      headerName: t("common.name"),
      width: 400,
      editable: false,
      headerAlign: "left",
      align: "left",
    },
  ];

  interface GrupoEmailRow {
    id: number;
    email: string;
  }

  interface GrupoRotina {
    id: number;
    nome: string;
  }

  function handleEmailRefChange(e: React.ChangeEvent<HTMLInputElement>) {
    setEmail((previousState) => {
      return { ...previousState, endereco: e.target.value };
    });
  }

  function handleGroupRefChange(e: React.ChangeEvent<HTMLInputElement>) {
    setGrupo((previousState) => {
      return { ...previousState, nome: e.target.value };
    });
  }

  function handleCreateNewEmail(event: FormEvent) {
    email.id === 0 && dataEmail.Adicionar(email);
    Mensagem(t("pages.emailsGroups.text.emailCreatedWithSuccess"));
    console.log(email);
  }

  function handleCreateNewGroup(event: FormEvent) {
    grupo.id === 0 && dataGrupo.Adicionar(grupo);
    Mensagem(t("pages.emailsGroups.text.registerUpdatedWithSuccess"));
    console.log(t("pages.emailsGroups.text.savingDataFrom") + grupo);
  }

  const handleGrupoSelectionChange = (id: any) => {
    setIdsGrupoSelecionados(id);
    console.log(`${t("common.groups")} ` + id);
  };

  const handleEmailSelectionChange = (id: any) => {
    setIdsEmailsSelecionados(id);
    console.log(`${t("common.emails")} ` + id);
  };

  const handleDeleteRegister = (cellValues: any) => {
    idsGrupoSelecionados.forEach((id) => {
      var paramToDel: Grupo = new Grupo();
      paramToDel.id = id;
      dataGrupo.Apagar(paramToDel);
    });
    Mensagem(t("pages.emailsGroups.text.groupRemovedWithSuccess"));
    console.log(JSON.stringify(idsGrupoSelecionados));
  };

  const handleDeleteEmail = (cellValues: any) => {
    idsEmailsSelecionados.forEach((id) => {
      var paramToDel: Email = new Email();
      paramToDel.id = id;
      dataEmail.Apagar(paramToDel);
    });
    Mensagem(t("pages.emailsGroups.text.emailRemovedWithSuccess"));
    console.log(JSON.stringify(idsEmailsSelecionados));
  };

  const Mensagem = (mensagem: string) => {
    return confirmAlert({
      message: mensagem,
      buttons: [
        {
          label: "Ok",
          onClick: () => {
            setOpen(false);
            PageHelper.refreshPage();
          },
        },
      ],
    });
  };

  return (
    <div className="container">
      <GrupoEmailsTopo />
      <div className="containerToolbar"></div>
      <div className="insiderContainer">
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Stack direction="row" spacing={2}>
              <TextField
                required
                id={"email"}
                name={"E-mail"}
                label={t("common.email")}
                placeholder={t("common.email")}
                variant="outlined"
                value={email.endereco}
                onChange={handleEmailRefChange}
                sx={{ width: "-webkit-fill-available" }}
              />
              <Tooltip title={t("pages.emailsGroups.text.emailRegister")}>
                <IconButton
                  className="group__btn-save"
                  onClick={handleCreateNewEmail}
                >
                  <SaveIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title={t("pages.emailsGroups.text.emailRemove")}>
                <IconButton
                  className="group__btn-save"
                  onClick={handleDeleteEmail}
                >
                  <EraseIcon />
                </IconButton>
              </Tooltip>
            </Stack>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Stack direction="row" spacing={2}>
              <TextField
                required
                id={"grupo"}
                name={"Grupo"}
                label={t("common.group")}
                variant="outlined"
                value={grupo.nome}
                onChange={handleGroupRefChange}
                sx={{ width: "-webkit-fill-available" }}
              />
              <Tooltip title={t("pages.emailsGroups.text.groupRegister")}>
                <IconButton
                  className="group__btn-save"
                  onClick={handleCreateNewGroup}
                >
                  <SaveIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title={t("pages.emailsGroups.text.groupRemove")}>
                <IconButton
                  className="group__btn-save"
                  onClick={handleDeleteRegister}
                >
                  <EraseIcon />
                </IconButton>
              </Tooltip>
            </Stack>
          </Grid>
        </Grid>
        <br />
      </div>
      <div className="group__main-content">
        <Grid className="group__content-box" container spacing={2}>
          <Grid item xs={12} sm={6}>
            <DataGrid
              rows={rowsEmail}
              columns={columnsEmail}
              rowsPerPageOptions={[50, 100, 250, 500]}
              onSelectionModelChange={(id) => {
                handleEmailSelectionChange(id);
              }}
              checkboxSelection
              disableSelectionOnClick
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <DataGrid
              rows={rowsGrupo}
              columns={columnsGrupo}
              onSelectionModelChange={(id) => {
                handleGrupoSelectionChange(id);
              }}
              rowsPerPageOptions={[50, 100, 250, 500]}
              checkboxSelection
              disableSelectionOnClick
            />
          </Grid>
        </Grid>
      </div>
      <GrupoEmailsModal
        openDialog={openEmailsVinculados}
        setOpenDialog={setOpenEmailsVinculados}
        grupoId={grupoId}
      />
      <GrupoRotinasModal
        openDialog={openRotinasVinculadas}
        setOpenDialog={setOpenRotinasVinculadas}
        grupoId={grupoId}
      />
    </div>
  );
}
